import React, { FC, useEffect } from "react";
import * as NavigationActions from "../../../actions/navigation";
import RestrictedLayout from "../../../components/layouts/RestrictedLayout";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { TrialInstitutionSettingsBreadcrumbs } from "../../../helpers/breadcrumbHelper";
import {
    SettingsSubMenu,
    SettingsTrialInstitutionSubMenu,
} from "../../../helpers/subMenuHelper";
import useDispatch, { useActionCreator } from "../../../hooks/useDispatch";
import useSelector from "../../../hooks/useSelector";
import SettingsCard from "../SettingsCard";

import "./TrialInstitutionSettingsPage.scss";

const TrialSettings: FC = () => {
    // Sidebar items
    const permissions = useSelector(
        (state) => state.user.userSummary?.permissions ?? []
    );
    const sideBarItems = SettingsSubMenu(permissions);

    // Breadcrumbs
    const breadcrumbs = TrialInstitutionSettingsBreadcrumbs();

    // Menu items
    const menuItems = SettingsTrialInstitutionSubMenu(permissions);

    const dispatch = useDispatch();
    const setDrawerItems = useActionCreator(
        NavigationActions.SetDrawerItems,
        dispatch
    );
    const setBreadcrumbs = useActionCreator(
        NavigationActions.SetBreadcrumbs,
        dispatch
    );

    useEffect(() => {
        setDrawerItems(sideBarItems);
        setBreadcrumbs(breadcrumbs);
    }, [setDrawerItems, setBreadcrumbs]);

    const renderTrialInstitutionSettingsCards = () => {
        return menuItems
            ?.filter((x) => x.description)
            ?.map((item, index) => (
                <SettingsCard
                    key={`item-${item.title}-${index}`}
                    navItem={item}
                />
            ));
    };

    return (
        <RestrictedLayout
            permission={Dtos.Permission.TrialInstitutionSettingsView}
        >
            <div className="settings-page">
                <div className="settings-container">
                    <h1 className="mb-4">Trial Institution</h1>
                    <div className="settings-grid">
                        {renderTrialInstitutionSettingsCards()}
                    </div>
                </div>
            </div>
        </RestrictedLayout>
    );
};

export default TrialSettings;
